export default __webpack_public_path__ + "static/media/logo.36738036.png";